import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { PiasLayoutComponent } from '../../shared/components/pias-layout/pias-layout.component';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { DashboardComponentsModule } from './dashboard-components/dashboard-components-module';
import { SessionStorageService } from '../../core/services/session-storage/session-storage.service';

@Component({
  selector: 'app-dashboard',
  imports: [
    CommonModule,
    PiasLayoutComponent,
    MatCardModule,
    MatTabsModule,

    DashboardComponentsModule
  ],
  standalone: true,
  templateUrl: './dashboard.page.html',
  styleUrl: './dashboard.page.scss'
})
export class DashboardPage implements OnInit {

  private sessionStorageService = inject(SessionStorageService);

  protected selectedTabId: string = "";
  protected currentUserRole: string = "";
  protected currentUserGroup: string = "";

  protected isAffinityUser = signal(false);

  constructor() { }

  ngOnInit(): void {
    this.selectedTabId = "incepted-ape";

    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.currentUserGroup = this.sessionStorageService.getCurrentUserGroup();

    if(['Affinity'].includes(this.currentUserGroup)) {
      this.isAffinityUser.set(true);
    }
  }

  protected __onDashboardTabChange(event: MatTabChangeEvent) {
    if (event.tab.id) {
      this.selectedTabId = event.tab.id.toString();
    } else {
      console.error(`Invalid tab ID for mat-tab[${event.index}]`);
    }
  }

}
